/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/testNotificationsMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a TestNotifications. */
export class TestNotifications {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a TestNotifications.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls Notification Hub to send notification
   * @summary Sends a notification to a single user on a device.
   * @param deviceId
   * @param body
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  sendNotificationToDevice(deviceId: string, body: Models.PushNotification, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param deviceId
   * @param body
   * @param callback The callback
   */
  sendNotificationToDevice(deviceId: string, body: Models.PushNotification, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param deviceId
   * @param body
   * @param options The optional parameters
   * @param callback The callback
   */
  sendNotificationToDevice(deviceId: string, body: Models.PushNotification, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  sendNotificationToDevice(deviceId: string, body: Models.PushNotification, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        body,
        options
      },
      sendNotificationToDeviceOperationSpec,
      callback);
  }

  /**
   * Calls Notification Hub to send ITP notification
   * @summary Sends an ITP push notification to a single user on a device.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  sendITPNotificationToDevice(deviceId: string, options?: Models.TestNotificationsSendITPNotificationToDeviceOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  sendITPNotificationToDevice(deviceId: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  sendITPNotificationToDevice(deviceId: string, options: Models.TestNotificationsSendITPNotificationToDeviceOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  sendITPNotificationToDevice(deviceId: string, options?: Models.TestNotificationsSendITPNotificationToDeviceOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      sendITPNotificationToDeviceOperationSpec,
      callback);
  }

  /**
   * Calls Notification Hub to send an ITM awareness notification.
   * @summary Sends an ITM awareness push notification to a single user's device.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  sendItmAwarenessNotificationToDevice(deviceId: string, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  sendItmAwarenessNotificationToDevice(deviceId: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  sendItmAwarenessNotificationToDevice(deviceId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  sendItmAwarenessNotificationToDevice(deviceId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      sendItmAwarenessNotificationToDeviceOperationSpec,
      callback);
  }

  /**
   * Calls Notification Hub to send an CM awareness notification.
   * @summary Sends an CM awareness push notification to a single user's device.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  sendCmAwarenessNotificationToDevice(deviceId: string, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  sendCmAwarenessNotificationToDevice(deviceId: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  sendCmAwarenessNotificationToDevice(deviceId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  sendCmAwarenessNotificationToDevice(deviceId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      sendCmAwarenessNotificationToDeviceOperationSpec,
      callback);
  }

  /**
   * Calls Notification Hub to send a cleanup inactive ITM user profile notification.
   * @summary Sends an cleanup inactive ITM user profile push notification to a single user's device.
   * @param deviceId
   * @param cleanupSubCategory Possible values include: 'FirstUserWarningNotificationEvent',
   * 'SecondUserWarningNotificationEvent', 'ThirdUserWarningNotificationEvent',
   * 'FirstOrganizerWarningNotificationEvent', 'SecondOrganizerWarningNotificationEvent',
   * 'ThirdOrganizerWarningNotificationEvent', 'UserCleanupNotificationEvent',
   * 'OrganizerCleanupMinorNotificationEvent', 'OrganizerCleanupNotMinorNotificationEvent'
   * @param warningPeriodDurationInDays
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  sendCleanupInactiveItmUserProfileNotificationToDevice(deviceId: string, cleanupSubCategory: Models.CleanupInactiveItmUserProfileCategory, warningPeriodDurationInDays: number, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param deviceId
   * @param cleanupSubCategory Possible values include: 'FirstUserWarningNotificationEvent',
   * 'SecondUserWarningNotificationEvent', 'ThirdUserWarningNotificationEvent',
   * 'FirstOrganizerWarningNotificationEvent', 'SecondOrganizerWarningNotificationEvent',
   * 'ThirdOrganizerWarningNotificationEvent', 'UserCleanupNotificationEvent',
   * 'OrganizerCleanupMinorNotificationEvent', 'OrganizerCleanupNotMinorNotificationEvent'
   * @param warningPeriodDurationInDays
   * @param callback The callback
   */
  sendCleanupInactiveItmUserProfileNotificationToDevice(deviceId: string, cleanupSubCategory: Models.CleanupInactiveItmUserProfileCategory, warningPeriodDurationInDays: number, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param deviceId
   * @param cleanupSubCategory Possible values include: 'FirstUserWarningNotificationEvent',
   * 'SecondUserWarningNotificationEvent', 'ThirdUserWarningNotificationEvent',
   * 'FirstOrganizerWarningNotificationEvent', 'SecondOrganizerWarningNotificationEvent',
   * 'ThirdOrganizerWarningNotificationEvent', 'UserCleanupNotificationEvent',
   * 'OrganizerCleanupMinorNotificationEvent', 'OrganizerCleanupNotMinorNotificationEvent'
   * @param warningPeriodDurationInDays
   * @param options The optional parameters
   * @param callback The callback
   */
  sendCleanupInactiveItmUserProfileNotificationToDevice(deviceId: string, cleanupSubCategory: Models.CleanupInactiveItmUserProfileCategory, warningPeriodDurationInDays: number, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  sendCleanupInactiveItmUserProfileNotificationToDevice(deviceId: string, cleanupSubCategory: Models.CleanupInactiveItmUserProfileCategory, warningPeriodDurationInDays: number, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        cleanupSubCategory,
        warningPeriodDurationInDays,
        options
      },
      sendCleanupInactiveItmUserProfileNotificationToDeviceOperationSpec,
      callback);
  }

  /**
   * Calls Notification Hub to send a second devices Rewards offer notification.
   * @summary Sends a second device Rewards offer push notification to a single user's device.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  sendSecondDeviceRewardsOfferNotificationToDevice(deviceId: string, options?: Models.TestNotificationsSendSecondDeviceRewardsOfferNotificationToDeviceOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  sendSecondDeviceRewardsOfferNotificationToDevice(deviceId: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  sendSecondDeviceRewardsOfferNotificationToDevice(deviceId: string, options: Models.TestNotificationsSendSecondDeviceRewardsOfferNotificationToDeviceOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  sendSecondDeviceRewardsOfferNotificationToDevice(deviceId: string, options?: Models.TestNotificationsSendSecondDeviceRewardsOfferNotificationToDeviceOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      sendSecondDeviceRewardsOfferNotificationToDeviceOperationSpec,
      callback);
  }

  /**
   * Calls Notification Hub to send stale device recovery notification notification.
   * @summary Sends a stale device recovery email notification to a single user to specified device
   * id.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  sendSlateDeviceRecoveryNotificationToDevice(deviceId: string, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  sendSlateDeviceRecoveryNotificationToDevice(deviceId: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  sendSlateDeviceRecoveryNotificationToDevice(deviceId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  sendSlateDeviceRecoveryNotificationToDevice(deviceId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      sendSlateDeviceRecoveryNotificationToDeviceOperationSpec,
      callback);
  }

  /**
   * Calls Notification Hub to send decommissioned client app notification.
   * @summary Sends a decommissioned client app to a single user's device.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  sendDecommissionedClientAppNotificationToDevice(deviceId: string, options?: Models.TestNotificationsSendDecommissionedClientAppNotificationToDeviceOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  sendDecommissionedClientAppNotificationToDevice(deviceId: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  sendDecommissionedClientAppNotificationToDevice(deviceId: string, options: Models.TestNotificationsSendDecommissionedClientAppNotificationToDeviceOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  sendDecommissionedClientAppNotificationToDevice(deviceId: string, options?: Models.TestNotificationsSendDecommissionedClientAppNotificationToDeviceOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      sendDecommissionedClientAppNotificationToDeviceOperationSpec,
      callback);
  }

  /**
   * Calls Notification Hub to send user recovery push notification.
   * @summary Sends a silent user recovery push notification to user's single device.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  sendUserRecoveryPushNotificationToDevice(deviceId: string, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  sendUserRecoveryPushNotificationToDevice(deviceId: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  sendUserRecoveryPushNotificationToDevice(deviceId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  sendUserRecoveryPushNotificationToDevice(deviceId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      sendUserRecoveryPushNotificationToDeviceOperationSpec,
      callback);
  }

  /**
   * Calls Notification Hub to send a Rewards completion notification.
   * @summary Sends a Rewards completion push notification to a single user's device.
   * @param deviceId
   * @param activity
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  sendSecondDeviceRewardsCompleteNotificationToDevice(deviceId: string, activity: string, options?: Models.TestNotificationsSendSecondDeviceRewardsCompleteNotificationToDeviceOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param deviceId
   * @param activity
   * @param callback The callback
   */
  sendSecondDeviceRewardsCompleteNotificationToDevice(deviceId: string, activity: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param deviceId
   * @param activity
   * @param options The optional parameters
   * @param callback The callback
   */
  sendSecondDeviceRewardsCompleteNotificationToDevice(deviceId: string, activity: string, options: Models.TestNotificationsSendSecondDeviceRewardsCompleteNotificationToDeviceOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  sendSecondDeviceRewardsCompleteNotificationToDevice(deviceId: string, activity: string, options?: Models.TestNotificationsSendSecondDeviceRewardsCompleteNotificationToDeviceOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        activity,
        options
      },
      sendSecondDeviceRewardsCompleteNotificationToDeviceOperationSpec,
      callback);
  }

  /**
   * Calls Notification Hub to send an Add Device notification.
   * @summary Sends an Add Device push notification to a single user's device.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  sendAddDevicePushNotificationToDevice(deviceId: string, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  sendAddDevicePushNotificationToDevice(deviceId: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  sendAddDevicePushNotificationToDevice(deviceId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  sendAddDevicePushNotificationToDevice(deviceId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      sendAddDevicePushNotificationToDeviceOperationSpec,
      callback);
  }

  /**
   * Calls Notification Hub to send a credit alert notification.
   * @summary Sends a credit alert push notification to a single user's device.
   * @param deviceId
   * @param creditAlertId
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  sendCreditAlertPushNotification(deviceId: string, creditAlertId: string, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param deviceId
   * @param creditAlertId
   * @param callback The callback
   */
  sendCreditAlertPushNotification(deviceId: string, creditAlertId: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param deviceId
   * @param creditAlertId
   * @param options The optional parameters
   * @param callback The callback
   */
  sendCreditAlertPushNotification(deviceId: string, creditAlertId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  sendCreditAlertPushNotification(deviceId: string, creditAlertId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        creditAlertId,
        options
      },
      sendCreditAlertPushNotificationOperationSpec,
      callback);
  }

  /**
   * Calls Notification Hub to send ITM notifications
   * @summary Sends an ITM awareness push notification to a user's devices.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  sendItmNotificationToDevices(options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  sendItmNotificationToDevices(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  sendItmNotificationToDevices(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  sendItmNotificationToDevices(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      sendItmNotificationToDevicesOperationSpec,
      callback);
  }

  /**
   * Calls Notification Hub to send CM notifications
   * @summary Sends an CM awareness push notification to a user's devices.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  sendCmNotificationToDevices(options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  sendCmNotificationToDevices(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  sendCmNotificationToDevices(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  sendCmNotificationToDevices(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      sendCmNotificationToDevicesOperationSpec,
      callback);
  }

  /**
   * Calls Iris to send a winback email.
   * @summary Sends a winback email to the user.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  sendWinbackEmailNotification(options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  sendWinbackEmailNotification(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  sendWinbackEmailNotification(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  sendWinbackEmailNotification(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      sendWinbackEmailNotificationOperationSpec,
      callback);
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const sendNotificationToDeviceOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/TestNotifications/device/{deviceId}/notifications",
  urlParameters: [
    Parameters.deviceId
  ],
  requestBody: {
    parameterPath: "body",
    mapper: {
      ...Mappers.PushNotification,
      required: true
    }
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const sendITPNotificationToDeviceOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/TestNotifications/device/{deviceId}/notifications/itp",
  urlParameters: [
    Parameters.deviceId
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.TestITPPushNotification
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const sendItmAwarenessNotificationToDeviceOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/TestNotifications/device/{deviceId}/notifications/itm/awareness",
  urlParameters: [
    Parameters.deviceId
  ],
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const sendCmAwarenessNotificationToDeviceOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/TestNotifications/device/{deviceId}/notifications/cm/awareness",
  urlParameters: [
    Parameters.deviceId
  ],
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const sendCleanupInactiveItmUserProfileNotificationToDeviceOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/TestNotifications/device/{deviceId}/notifications/cleanup/inactive/itm/{cleanupSubCategory}/{warningPeriodDurationInDays}",
  urlParameters: [
    Parameters.deviceId,
    Parameters.cleanupSubCategory,
    Parameters.warningPeriodDurationInDays
  ],
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const sendSecondDeviceRewardsOfferNotificationToDeviceOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/TestNotifications/device/{deviceId}/notifications/rewards/second_device",
  urlParameters: [
    Parameters.deviceId
  ],
  queryParameters: [
    Parameters.points
  ],
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const sendSlateDeviceRecoveryNotificationToDeviceOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/TestNotifications/device/{deviceId}/notifications/staleDeviceRecovery",
  urlParameters: [
    Parameters.deviceId
  ],
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const sendDecommissionedClientAppNotificationToDeviceOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/TestNotifications/device/{deviceId}/notifications/app/decommissioned",
  urlParameters: [
    Parameters.deviceId
  ],
  queryParameters: [
    Parameters.variation
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: {
      serializedName: "body",
      type: {
        name: "DateTime"
      }
    }
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const sendUserRecoveryPushNotificationToDeviceOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/TestNotifications/device/{deviceId}/notifications/userrecovery",
  urlParameters: [
    Parameters.deviceId
  ],
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const sendSecondDeviceRewardsCompleteNotificationToDeviceOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/TestNotifications/device/{deviceId}/notifications/rewards/complete/{activity}",
  urlParameters: [
    Parameters.deviceId,
    Parameters.activity
  ],
  queryParameters: [
    Parameters.points
  ],
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const sendAddDevicePushNotificationToDeviceOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/TestNotifications/device/{deviceId}/notifications/addDevice/second_device",
  urlParameters: [
    Parameters.deviceId
  ],
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const sendCreditAlertPushNotificationOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/TestNotifications/device/{deviceId}/credit/{creditAlertId}",
  urlParameters: [
    Parameters.deviceId,
    Parameters.creditAlertId
  ],
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const sendItmNotificationToDevicesOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/TestNotifications/notifications/itm/awareness",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const sendCmNotificationToDevicesOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/TestNotifications/notifications/cm/awareness",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const sendWinbackEmailNotificationOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/TestNotifications/email/winback",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
